import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Brand, Brands } from 'src/app/shared/const/brand';
import { customer, itemSelectObject, segment } from 'src/app/shared/const/select';
import { InspectionModel } from 'src/app/shared/models/inspection.model';
import { OpenedInspectionRegistrationService } from 'src/app/shared/services/opened-inspection-registration.service';

@Component({
  selector: 'app-select-customer',
  templateUrl: './select-customer.component.html',
  styleUrls: ['./select-customer.component.scss']
})
export class SelectCustomerComponent implements OnInit {

  formCustomer: FormGroup;
  imagePath: string = '';
  listCustomer: itemSelectObject[] = [];
  listSegment: itemSelectObject[] = [];
  showLogo: boolean = false;
  showCard: boolean = false;
  showField: boolean = false;
  showBikeField: boolean = false;
  showForm: boolean = false;
  enableRequiredField: boolean = false;
  inspectionBody: InspectionModel | null;

  constructor(
    private fb: FormBuilder,
    private _openedInspectionRegistrationService: OpenedInspectionRegistrationService,
    private toastrService: ToastrService) { }

  

  ngOnInit(): void {

    this.loadForm();
    
    this.listCustomer = customer;
    
    this.loadSegmentOptions();
  }

  loadForm() {
    this.formCustomer = this.fb.group({
      selectCustomer: [''],
      broker: this.fb.group({
        brokerCode: [''],
        corporateName: ['', Validators.required],
        companyRegistrationNumber: ['', Validators.required],
        brokerMail: ['', [Validators.required, Validators.email]],
        brokerName: ['', Validators.required],
        proposalNumber: ['', Validators.required]
      }),
      selectSegment: ['0'],
      insured: this.fb.group({
        insuredName: ['', Validators.required],
        insuredMobileNumber: ['', Validators.required]
      }),
      vehicle: this.fb.group({
        vehiclePlate: [''],
        vehicleBrand: [''],
        vehicleChassi: [''],
        vehicleModel: [''],
        vehicleYearManufacture: [''],
        vehicleYearModel: ['']
      })
    });
  }

  loadSegmentOptions(): void {
    this._openedInspectionRegistrationService.getListSegment().then((response: itemSelectObject[]) => {
      this.listSegment = [
        { id: '0', name: 'Selecione um segmento' },
        ...response.sort((a, b) => a.name.localeCompare(b.name))
      ];
      this.formCustomer.controls['selectSegment'].setValue(this.listSegment[0].id);
    });
  }

  searchBroker() {
    let code = this.formCustomer.get('broker.brokerCode')?.value;
    let dataCompany = JSON.parse(localStorage.getItem('company') || '{}');
    if (!!code) {
      this._openedInspectionRegistrationService.getBrokerByCode(code, dataCompany.companyId).then((response: any) => {
        if (response) {
          this.showForm = true;
          this.formCustomer.get('broker.corporateName').setValue(response.BrokerName);
        } else {
          this.toastrService.error('Código corretor não localizado, favor informar ao seu comercial.', 'Erro')
        } 
      });
    }
  }

  onSelectCustomer() {
    this._openedInspectionRegistrationService.setLocalStorageCompany(this.formCustomer.value.selectCustomer);
    this.showCard = true;
    this.getLogo(this.formCustomer.value.selectCustomer);
  }

  getLogo(companyId: string) {
    const imageName = Brands.filter(brand => brand.id === companyId)[0].file;
    this.showLogo = !!imageName;
    this.imagePath = `assets/images/logos/${imageName}`;
  }

  onSelectSegment() {
    this.showField = this.formCustomer.value.selectSegment !== '6';
    this.showBikeField =  this.formCustomer.value.selectSegment === '6';

    const vehicleGroup = this.formCustomer.get('vehicle') as FormGroup;
    const insuredGroup = this.formCustomer.get('insured') as FormGroup;
    if (this.showField) {
      if (vehicleGroup) {
        vehicleGroup.reset();
        insuredGroup.reset();
        vehicleGroup.get('vehiclePlate')?.setValidators(Validators.required);
        vehicleGroup.get('vehicleChassi')?.setValidators(Validators.required);
        vehicleGroup.get('vehicleBrand')?.setValidators(Validators.required);
        vehicleGroup.get('vehicleModel')?.setValidators(Validators.required);
        vehicleGroup.get('vehicleYearManufacture')?.setValidators(Validators.required);
        vehicleGroup.get('vehicleYearModel')?.setValidators(Validators.required);

        vehicleGroup.updateValueAndValidity();
      }
    }else if (this.showBikeField) {
      vehicleGroup.reset();
      insuredGroup.reset();
      vehicleGroup.get('vehicleModel')?.setValidators(Validators.required);
      
      vehicleGroup.updateValueAndValidity();
    }else {
      if (vehicleGroup) {
        vehicleGroup.reset();
        insuredGroup.reset();
        Object.keys(vehicleGroup.controls).forEach(controlName => {
          const control = vehicleGroup.get(controlName);
          control?.clearValidators();
          control?.updateValueAndValidity();
        });
    
        vehicleGroup.updateValueAndValidity();
      }
    }
  }

  setPlateUppercase(): void {
    const plateControl = this.formCustomer.get('vehicle.vehiclePlate');
    plateControl?.setValue(plateControl.value.toUpperCase());
  }

  saveInspection(): void {
    if (this.formCustomer.valid) {
      const companyData = JSON.parse(localStorage.getItem('company') || '{}');
      this.inspectionBody = {} as InspectionModel;
      
      this.inspectionBody.insuredInspection = this.inspectionBody.insuredInspection || {} as any;
      this.inspectionBody.vehicleInspection = this.inspectionBody.vehicleInspection || {} as any;
      this.inspectionBody.dateRegister = new Date().toISOString();
      this.inspectionBody.dateChanged = new Date().toISOString();
      this.inspectionBody.surveyType = 1;
      this.inspectionBody.insuranceId = companyData.insuranceId;
      this.inspectionBody.providerCode = companyData.companyId;
      this.inspectionBody.brokerCode = this.formCustomer.value.broker.brokerCode;
      this.inspectionBody.brokerName = this.formCustomer.value.broker.brokerName;
      this.inspectionBody.brokerMail = this.formCustomer.value.broker.brokerMail;
      this.inspectionBody.proposedNumber = this.formCustomer.value.broker.proposalNumber;
      this.inspectionBody.segment = this.formCustomer.value.selectSegment;
      this.inspectionBody.insuredInspection.name = this.formCustomer.value.insured.insuredName;
      this.inspectionBody.insuredInspection.cellPhoneNumber = this.formCustomer.value.insured.insuredMobileNumber;
      this.inspectionBody.vehicleInspection.plate = this.formCustomer.value.vehicle.vehiclePlate;
      this.inspectionBody.vehicleInspection.chassis = this.formCustomer.value.vehicle.vehicleChassi;
      this.inspectionBody.vehicleInspection.vehicleBrand = this.formCustomer.value.vehicle.vehicleBrand;
      this.inspectionBody.vehicleInspection.vehicleModel = this.formCustomer.value.vehicle.vehicleModel;
      this.inspectionBody.vehicleInspection.yearOfManufacture = this.formCustomer.value.vehicle.vehicleYearManufacture;
      this.inspectionBody.vehicleInspection.modelyear = this.formCustomer.value.vehicle.vehicleYearModel;
      this.inspectionBody.stateInspection = '1';
      this._openedInspectionRegistrationService.createInspectionLoose(this.inspectionBody).then((response: any) => {
        if (response) {
          this.loadForm();
          this.showLogo = false;
          this.showCard = false;
          this.showField = false;
          this.showForm = false;
          this.toastrService.success('Inspeção salva com sucesso!', 'Sucesso');
        } else {
          this.toastrService.error('Erro ao salvar a inspeção.', 'Erro');
        }
      });
    } else {
      this.formCustomer.markAllAsTouched();
      this.toastrService.error('Preencha todos os campos obrigatórios.', 'Erro');
    }
  }

  checkVehicleSegment(code): boolean {
    return code === '1' ? true : false;
  }

  checkBikeSegment(code): boolean {
    return code === '6' ? true : false;
  }

  checkTruckSegment(code): boolean {
    return code === '3' ? true : false;
  }

  checkMotorcycleSegment(code): boolean { 
    return code === '2' ? true : false
  }

  isInvalid(groupName: string, controlName: string): boolean {
    const group = this.formCustomer.get(groupName);
    const control = group?.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}
